import React from "react";
import ProfilePic from "../images/hanna-temp.jpg";

const About = (): any => {
  return (
    <>
      <div className="wrapper">
        <div className="profile-content section">
          <div className="container">
            <div className="row">
              <div className="profile-picture">
                <div
                  className="fileinput fileinput-new"
                  data-provides="fileinput"
                >
                  <div className="fileinput-new img-no-padding">
                    <img
                      src={ProfilePic}
                      alt="Hanna Kaciniel - Profile Picture"
                      className="img-circle img-no-padding img-responsive"
                    />
                  </div>
                  <div className="name">
                    <h4 className="title text-center">
                      Hanna Kaciniel
                      <br />
                      <small>Artist</small>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 ml-auto mr-auto text-center">
                <p>
                  An artist of considerable range, Chet Faker — the name taken
                  by Melbourne-raised, Brooklyn-based Nick Murphy — writes,
                  performs and records all of his own music, giving it a warm,
                  intimate feel with a solid groove structure.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    /*<div className="section">
            <div className="container">
              <div className="row">
                <div className="col-md-8 ml-auto mr-auto text-left">
                  <h1 className="title">About</h1>
                  <h5 className="description">
                  <p>
                    Hanna Kaciniel Was born in 1978 in the small village of Koczala in the north of Poland 115km South West of the regional capital and Poland's principal seaport Gdansk.
                    This was a period when Poland still formed part of the Communist USSR and it was not until 1989, when Hanna was 11, during the Revolutions of 1989, that Poland gained its independence and began its democratic transition.
                    Her rural village had a small military base and was dominated by government food farms. Like many of the population, Hanna's parents were both employed by the government. She is the eldest of six children.
                </p>
                <p>
                    As a young child her Grandfather spent time with Hanna, teaching her how to draw, not knowing that his actions would bring her to where she is today.
                    Hanna would have loved to go to one of the Art Academies in Warsaw or Krakow( realistically you needed a lot of money to attend to these schools), but she was content to settle for Koszalin, a provincial Art School where she moved to at the age of 15, Koszalin offered her a broad-besed 5 year course thet included art history, economics and intensive art-based content. It would give her the foundation of her art career.
                </p>
                <p>Not that easy, because in real life you need to generate money. When you speak to Hanna she has a lovely soft nature, prone to humor but she also has a very impressive work ethic. She had always had her sights set on developing an art career and it is somewhat inspiring that she has been prepared to work hard to generate funds to allow her to fulfill her ambitions.</p>
                <p>
                    She has an infectious determination, Indeed she came to Scotland with the objective that she could build her earnings to give her the time and space to develop her painting style. She has settled( married to a Scot David) and they have a lovely daughter Halina. We see enormous potential in Hanna.
                    From the first time I set eyes on her work, I could see there was something special about her ability, Scottish art needs someone like Hanna- new eyes and a lovely freshness.
                </p>
                <p>
                    With a bit of encouragement, we asked her to re-position from a classical style into, what is a relatively unpopulated space-modern art in Scotland. In her new Pop Art, we are seeing a remarkably clever and well-thought-out response to the challenge we set her-she is positively blossoming.
                    This is powerful art. She is giving us a wonderful, new art form that we have been waiting for. All the cheeky rebelliousness of Pop Art in an updated contemporary setting. Still life(not flowers) that mirrors modern society and culture.
                    Remember the character- soft and prone to humor! Well, that profile walks right through her paintings. They demonstrate an incredible artistic talent and exude her charm and character
                </p>
                <strong>Ken Lemond</strong>
                  </h5>
                </div>
              </div>
              <hr />
            </div>
          </div>*/
  );
};

export default About;
